import { styled } from '@mui/material/styles';

export const StyledWrapper = styled('div')(({theme}) => ({
	padding: theme.spacing(3),
	backgroundColor: theme.palette.background.default,
	borderRadius: theme.spacing(1),
	position: 'relative',
	zIndex: '1',
}))
